import { generateUUID } from "./uuid";
import { BrowserStorage } from "~/utils/browser";

export type DeviceId = string;

export function createNewDeviceId() {
  let deviceId: string;

  try {
    deviceId = `$device:${generateUUID()}`;
  } catch (_error) {
    deviceId = `$device:default-${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;
  }

  return deviceId;
}

export function getDeviceId(): string {
  const storage = new BrowserStorage();
  let deviceId = storage.getItem("localLogicDevice");

  if (!deviceId) {
    deviceId = createNewDeviceId();
    storage.setItem("localLogicDevice", deviceId);
  }

  return deviceId;
}
